import styled from '@emotion/styled'
import { WhiteSpinner } from '../icons/Icons'

type LoadingScreenProps = {
    style?: React.CSSProperties
    showLoader?: boolean
}

const LoadingScreenContainer = styled.div({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'inherit',
    pointerEvents: 'auto',
    backgroundColor: 'transparent',
    zIndex: -1,
    color: 'white',
    top: 0,
    position: 'absolute',
})

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ style }) => {
    const loadingStyles = style != null ? style : {}
    return (
        <LoadingScreenContainer style={loadingStyles}>
            <div>
                <WhiteSpinner />
            </div>
        </LoadingScreenContainer>
    )
}
